import userRoles from 'utils/enums/user-roles.enum';

export default {
	adminPanel: {
		title: 'Admin Panel',
		items: {
			adminPanel: {
				read: [userRoles.Admin],
			},
			featureSubscriptionPanel: {
				title: 'Feature Subscription panel (View Only)',
				create: [userRoles.Admin],
				read: [userRoles.Admin],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
			configurationPanel: {
				title: 'Configuration Panel',
				create: [userRoles.Admin],
				read: [userRoles.Admin],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
			userManagement: {
				title: 'User Management',
				create: [userRoles.Admin],
				read: [userRoles.Admin],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
			reportThresholds: {
				title: 'Thresholds',
				create: [userRoles.Admin],
				read: [userRoles.Admin],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
			licensing: {
				title: 'Licensing',
				create: [userRoles.Admin],
				read: [userRoles.Admin],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
			billingReport: {
				title: 'Billing Report',
				create: [userRoles.Admin],
				read: [userRoles.Admin],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
		},
	},
	contactCenter: {
		title: 'Contact Center',
		items: {
			contactCenter: {
				title: 'Contact Center',
				create: [userRoles.Admin],
				read: [userRoles.Admin, userRoles.CustomerRepresentative],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
			preCallNotificationDefault: {
				title: 'Pre-Call notification default',
				create: [userRoles.Admin],
				read: [userRoles.Admin, userRoles.CustomerRepresentative],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
			preCallNotificationCustom: {
				title: 'Pre-Call notification custom',
				create: [userRoles.Admin, userRoles.CustomerRepresentative],
				read: [userRoles.Admin, userRoles.CustomerRepresentative],
				update: [userRoles.Admin, userRoles.CustomerRepresentative],
				delete: [userRoles.Admin, userRoles.CustomerRepresentative],
			},
			unVerifiedCallArrivalNotification: {
				title: 'UnVerified Call Arrival Notification',
				create: [userRoles.Admin],
				read: [userRoles.Admin, userRoles.CustomerRepresentative],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
			spoofPreventionList: {
				title: 'Spoof Prevention List',
				create: [userRoles.Admin],
				read: [userRoles.Admin],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
			skinsUpload: {
				title: 'Mobile Call Arrival Skins Upload',
				create: [userRoles.Admin],
				read: [userRoles.Admin, userRoles.CustomerRepresentative],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
		},
	},
	marketing: {
		title: 'Marketing',
		items: {
			broadcast: {
				title: 'Broadcast',
				create: [userRoles.Admin],
				read: [userRoles.Admin],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
			targetedGroupWithList: {
				title: 'Targeted Group with a list',
				create: [userRoles.Admin],
				read: [userRoles.Admin],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
		},
	},
	scheduler: {
		title: 'Scheduler',
		items: {
			scheduleCall: {
				title: 'Schedule a call',
				create: [userRoles.Admin, userRoles.CustomerRepresentative],
				read: [userRoles.Admin, userRoles.CustomerRepresentative],
				update: [userRoles.Admin, userRoles.CustomerRepresentative],
				delete: [userRoles.Admin, userRoles.CustomerRepresentative],
			},
			rescheduleCall: {
				title: 'Reschedule a call',
				create: [userRoles.Admin, userRoles.CustomerRepresentative],
				read: [userRoles.Admin, userRoles.CustomerRepresentative],
				update: [userRoles.Admin, userRoles.CustomerRepresentative],
				delete: [userRoles.Admin, userRoles.CustomerRepresentative],
			},
			cancelCall: {
				title: 'Cancel a Call',
				create: [userRoles.Admin, userRoles.CustomerRepresentative],
				read: [userRoles.Admin, userRoles.CustomerRepresentative],
				update: [userRoles.Admin, userRoles.CustomerRepresentative],
				delete: [userRoles.Admin, userRoles.CustomerRepresentative],
			},
			calendarViewForUser: {
				title: 'Calendar view for user',
				create: [userRoles.Admin, userRoles.CustomerRepresentative],
				read: [userRoles.Admin, userRoles.CustomerRepresentative],
				update: [userRoles.Admin, userRoles.CustomerRepresentative],
				delete: [userRoles.Admin, userRoles.CustomerRepresentative],
			},
			calendarViewForAdmin: {
				title: ' Calendar/List view of CSR Appointments',
				create: [userRoles.Admin],
				read: [userRoles.Admin],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
		},
	},
	pushNotificationsLog: {
		title: 'Push Notifications',
		items: {
			pushNotificationsLog: {
				title: 'Push Notifications Log',
				create: [userRoles.Admin],
				read: [userRoles.Admin, userRoles.CustomerRepresentative],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
			downloadCsv: {
				title: 'Download .csv',
				create: [userRoles.Admin],
				read: [userRoles.Admin],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
		},
	},
	rating: {
		title: 'Rating',
		items: {
			messageForRequestingRating: {
				title: 'Message for requesting rating',
				create: [userRoles.Admin, userRoles.CustomerRepresentative],
				read: [userRoles.Admin, userRoles.CustomerRepresentative],
				update: [userRoles.Admin, userRoles.CustomerRepresentative],
				delete: [userRoles.Admin, userRoles.CustomerRepresentative],
			},
		},
	},
	statistics: {
		title: 'Statistics',
		items: {
			executiveDashboard: {
				title: 'Dashboards',
				create: [userRoles.Admin],
				read: [userRoles.Admin],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
		},
	},
	customerRegistration: {
		title: 'Customer Registrations',
		items: {
			customerRegistrationInformationView: {
				title: 'Customer Registration Information',
				create: [userRoles.Admin],
				read: [userRoles.Admin, userRoles.CustomerRepresentative],
				update: [userRoles.Admin],
				delete: [userRoles.Admin],
			},
		},
	},
};
